import './hero.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';


const Hero = () => {

  // Funzione per fare scroll down di 100vh
  function scrollDown(){
    window.scrollBy({
      top: window.innerHeight,
      left: 0,
      behavior: 'smooth',
    });
  }

  return (
    <div className="hero">
        <div className="vert-flexbox title-container">
            <h1 className="titolo">Shadows of Lux</h1>
            <h2 className="sottotesto">Di Andrea Comito</h2>
            <div className="hor-flexbox line-btn-container">
                <div className="line"></div>
                <button className="my-art-btn" onClick={scrollDown}>I miei articoli <FontAwesomeIcon icon={faChevronDown}/></button>
                <div className="line"></div>
            </div>
        </div>
    </div>
  )
}

export default Hero